/**
=========================================================
* EGEAD Fulfilment POD - v2.2.0
=========================================================

* Product Page: https://www.egeadcompany.com/product/material-dashboard-react
* Copyright 2023 Dev Egead Company (https://www.egeadcompany.com)

Coded by www.egeadcompany.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import ArrowCircleRightTwoToneIcon from '@mui/icons-material/ArrowCircleRightTwoTone';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import Card from "@mui/material/Card";
// Using HTML components instead
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import { fontSize, styled } from '@mui/system';
// Using pure HTML instead of components
import MDPagination from 'components/MDPagination';
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import NoteDialog from 'examples/NoteDialog';
import HTMLDataTable from "examples/Tables/HTMLDataTable";
import { editOrder, ffbeeful, ffmango, ffmerchfox, ffpabeeful, ffprintik, ffprintway, getOrders, bulkUpdateOrders } from "features/slices";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import CheckIcon from '@mui/icons-material/Check';
import bcrypt from 'bcryptjs';
import { NotificationManager } from "react-notifications";
import { useDispatch, useSelector } from "react-redux";
import beeful from "./beeful";
import mango from './mango';
import merchfox from "./merchfox";
import teecraft from "./teecraft";
import { updateCurrentPage } from 'features/slices';
import { ffteecraft } from 'features/slices';
import printik from './printik';
import apbeeful from './apbeeful';
const Section = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(1),
}));

const GreenSection = styled(Section)({
});

const BlueSection = styled(Section)({
  background: 'linear-gradient(195deg, #9dbdba, #9dbdba)',
  width: "100%",
  display: "flex",
  flexDirection: "row"
});

const DarkSection = styled(Section)({
  background: 'linear-gradient(195deg, #42424a, #191919)',
});

const CaptionText = styled('p')({
  display: "flex",
  flexDirection: "row",
  fontWeight: 'bold',
  marginTop: 4,
  fontSize: "14px",
  color: "#344767",
});

const CaptionText2 = styled('p')({
  fontWeight: 'bold',
  marginTop: 4,
  color: "white",
  fontSize: "14px",
});

const InfoText = styled('span')({
  marginLeft: 5,
  color: "#344767"
});

const NormalText = styled('span')({
  fontWeight: '400',
  marginLeft: 5,
  color: 'inherit',
});

const HighlightedText = styled('span')({
  fontWeight: '500',
  color: 'orange',
  marginLeft: 5,
  fontSize: "14px"

});

const RedText = styled('span')({
  color: 'red',
  fontWeight: 'bold',
});
const ffSite = ["Merchfox", "Mango", "Beeful", "PA-Beeful", "Printify", "Printway", "Burgershop", "Printik"]

function Tables() {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.user.data || []);
  const permission = useSelector((state) => state.user.permission || []);
  const startDate = useSelector((state) => state.user.startDate);
  const type = useSelector((state) => state.user.type);
  const filterStore = useSelector((state) => state.user.filterStore);
  const order_status = useSelector((state) => state.user.order_status);
  const endDate = useSelector((state) => state.user.endDate);
  const user = useSelector((state) => state.user.user);
  const search = useSelector((state) => state.user.search);
  const currentPage = useSelector((state) => state.user.currentPage) || 1

  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [open5, setOpen5] = useState(false);
  const [open6, setOpen6] = useState(false);
  const [open7, setOpen7] = useState(false);
  const [open8, setOpen8] = useState(false);
  const [clear, setClear] = useState("");
  const [color, setColor] = useState("");
  const [size, setSize] = useState("");
  const [itemEditor, setItemEditor] = useState({})
  const [tracking, setTracking] = useState("");
  const [fulfil, setFulfil] = useState("");
  const [lineship, setLineship] = useState("");
  const [note, setNote] = useState("");
  const [basecost, setBasecost] = useState("");
  const [ff, setFf] = useState("Merchfox");
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedOrderItems, setSelectedOrderItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [openBulkDialog, setOpenBulkDialog] = useState(false);
  const [bulkFF, setBulkFF] = useState("");
  const [bulkStatusFulfil, setBulkStatusFulfil] = useState(false);
  const [openShippingDialog, setOpenShippingDialog] = useState(false);
  const [shippingMethod, setShippingMethod] = useState("");

  function modifyUrlString(inputString) {
    if (inputString.includes("/cdn-cgi")) {
      const regex = /https:\/\//g;
      const matches = inputString.match(regex);
      if (!matches) {
        return inputString;
      } else if (matches.length === 1) {
        return 'https://' + inputString.split('https://')[1]
      } else if (matches.length === 2) {
        const parts = inputString.split('https://');
        return 'https://' + parts[2];
      } else {
        return inputString;
      }
    } else {
      return inputString;
    }

  }

  const handleDeleteNote = async (index) => {
    const updatedNotes = itemEditor.note.split("\n").filter((_, i) => i !== index);
    const res = await dispatch(editOrder({ user, field: "note", string: updatedNotes.join("\n"), id: itemEditor.id }))
    if (res.payload.status == 0) {
      // await dispatch(
      //   getOrders({
      //     store: filterStore, order_status,
      //     startDate: moment(startDate).startOf("day").format("x"),
      //     endDate: moment(endDate).endOf("day").format("x"), currentPage, search, type
      //   })
      // );
      bcrypt.genSalt(10, (err, salt) => {
        bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
          const time = moment().unix()
          const res = await dispatch(getOrders({
            store: filterStore, order_status,
            startDate: moment(startDate).startOf("day").format("x"),
            endDate: moment(endDate).endOf("day").format("x"),
            currentPage,
            search,
            version: hash,
            type
          }))

        });
      })
    }
    setOpen2(false)
  };
  const handleOrderItemCheckboxChange = (item) => (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const newSelectedItems = [...selectedOrderItems, item.id];
      setSelectedOrderItems(newSelectedItems);
      // Kiểm tra nếu tất cả items có price và chưa fulfil đã được chọn
      const itemsWithPriceAndNotFulfilled = data.data ? data.data.filter(item => item.price && !item.status_fulfil && !item.fulfil) : [];
      if (newSelectedItems.length === itemsWithPriceAndNotFulfilled.length) {
        setSelectAll(true);
      }
    } else {
      setSelectedOrderItems(prev => prev.filter(id => id !== item.id));
      setSelectAll(false);
    }
  };

  const handleSelectAllChange = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);
    if (isChecked) {
      const allItemIds = data.data ? data.data.filter(item => item.price && !item.status_fulfil && !item.fulfil).map(item => item.id) : [];
      setSelectedOrderItems(allItemIds);
    } else {
      setSelectedOrderItems([]);
    }
  };

  const handleCheckboxChange = (item) => (event) => {
    const tshirt = ["YouthT-Shirt", "WomenT-Shirt", "UnisexT-Shirt", "WomensV-NeckT-Shirt", "V-NeckT-Shirt"]
    let have = ""
    let size = item.size.replace("*", "").replace("Type: ", "")
      .replace("Fabric Brand: ", "")
      .replace("Style: ", "")
      .replace("Size: ", "")
      .replace(/'/g, "")
      .replace("Product Sides Options: ", "").replace(/ /g, "")
    let sizeArray = size.split("-")
    for (let i of tshirt) {
      if (size.includes(i)) {
        have = i
        size = size.replace(`${i}-`, "")
        sizeArray = size.split("-")
        sizeArray.splice(2, 0, i);
        break;
      }
    }
    let ffSKU = []
    let cate = ""
    let mainProduct = []
    if (ff == "Mango") {
      mainProduct = mango.filter(items => items.sku == `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}`)
      ffSKU = mainProduct?.[0]?.variations.filter(items => {
        return items.size.toUpperCase().replace(/ /g, "") == sizeArray?.[3].toUpperCase().replace(/ /g, "") && items.color.toUpperCase().replace(/ /g, "") == item.color.toUpperCase().replace(/ /g, "")
      }) || []
      if (!ffSKU.length) {
        NotificationManager.error(`Mango does not have this data variable!`, "Error", 2000);
        return
      }
    } else if (ff == "Teecraft") {
      mainProduct = teecraft.filter(items => items.sku == `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}`)
      ffSKU = mainProduct?.[0]?.variations.filter(items => {
        return items.size.toUpperCase().replace(/ /g, "") == sizeArray?.[3].toUpperCase().replace(/ /g, "") && items.color.toUpperCase().replace(/ /g, "") == item.color.toUpperCase().replace(/ /g, "")
      }) || []
      if (!ffSKU.length) {
        NotificationManager.error(`Teecraft does not have this data variable!`, "Error", 2000);
        return
      }
      cate = mainProduct?.[0].category
    }
    else if (ff == "Beeful") {
      mainProduct = beeful.filter(items => items.name == `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}`)
      ffSKU = mainProduct?.[0]?.variations.filter(items => {
        return items.size.toUpperCase().replace(/ /g, "") == sizeArray?.[3].toUpperCase().replace(/ /g, "") && items.color.toUpperCase().replace(/ /g, "") == item.color.toUpperCase().replace(/ /g, "")
      }) || []
      if (!ffSKU.length) {
        NotificationManager.error(`Beeful does not have this data variable!`, "Error", 2000);
        return
      }
    } else if (ff == "PA-Beeful") {
      mainProduct = apbeeful.filter(items => items.name == `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}`)
      ffSKU = mainProduct?.[0]?.variations.filter(items => {
        return items.size.toUpperCase().replace(/ /g, "") == sizeArray?.[3].toUpperCase().replace(/ /g, "") && items.color.toUpperCase().replace(/ /g, "") == item.color.toUpperCase().replace(/ /g, "")
      }) || []
      if (!ffSKU.length) {
        NotificationManager.error(`Beeful does not have this data variable!`, "Error", 2000);
        return
      }
    } else if (ff == "Printik") {
      mainProduct = printik.filter(items => items.sku == `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}`)
      ffSKU = mainProduct?.[0]?.variations.filter(items => {
        return items.size.toUpperCase().replace(/ /g, "") == sizeArray?.[3].toUpperCase().replace(/ /g, "") && items.color.toUpperCase().replace(/ /g, "") == item.color.toUpperCase().replace(/ /g, "")
      }) || []
      if (!ffSKU.length) {
        NotificationManager.error(`Printik does not have this data variable!`, "Error", 2000);
        return
      }
    }
    else if (ff == "Merchfox") {
      mainProduct = item.size.includes("Size: US") ? merchfox.filter(items => items.sku == "Crocs") : merchfox.filter(items => items.sku == `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}`)
      if (mainProduct.length) {
        if (item.size.includes("Size: US") && !mainProduct[0].size.some(items => items[1] == sizeArray[2])) {
          NotificationManager.error("Crocs Merchfox does not have this size!", "Error", 2000);
        }
        if (!item.size.includes("Size: US") && !mainProduct[0].size.some(items => items == sizeArray?.[3])) {
          NotificationManager.error("Merchfox does not have this size!", "Error", 2000);
          return;
        }
        if (!mainProduct[0].color.some(items =>
          `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}` == "Unisex-BellaCanvas-UnisexT-Shirt" || `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}` == "Unisex-ComfortColor-UnisexT-Shirt" ?
            items.trim().toUpperCase() == item.color.trim().toUpperCase() :
            items.trim().toUpperCase() == item.color.trim().toUpperCase()
        ) && !item.size.includes("Size: US")) {
          NotificationManager.error(`Merchfox does not have this color!`, "Error", 2000);
          return;
        }
      } else {
        NotificationManager.error(`Merchfox does not have this data variable!`, "Error", 2000);
        return
      }
    } else {
      return
    }

    if ((item.size.replace("*", "").includes("Both Sides") && item.design_link?.front && item.design_link?.back) || ((item.size.replace("*", "").includes("Front Side Only") || item.size.replace("*", "").includes("Front Side only")) && item.design_link?.front) || ((item.size.replace("*", "").includes("Back Side Only") || item.size.replace("*", "").includes("Back Side only")) && item.design_link?.back) || (item.size.replace("*", "").includes("Size: US") && item.design_link?.front)) {
      const itemId = item.id;
      const isChecked = event.target.checked;
      let sizeCrocs = ""
      if (item.size.includes("Size: US")) {
        sizeCrocs = mainProduct[0].size.filter(items => items[1] == sizeArray[2])
      }
      if (item.size.includes("Size: US") && !sizeCrocs) {
        NotificationManager.error(`Merchfox does not have this size!`, "Error", 2000);
        return;
      }
      try {
        setSelectedItems(prev => ({
          ...prev,
          [itemId]: isChecked ? {
            id: mainProduct?.[0]?.id || ffSKU?.[0]?.id, cate, product: null, size: item.size.includes("Size: US") ? sizeCrocs[0][0] : sizeArray?.[3], color: item.size.includes("Size: US") ? "3D Printed" : `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}` == "Unisex-BellaCanvas-UnisexT-Shirt" || `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}` == "Unisex-ComfortColor-UnisexT-Shirt" ? item.color.trim() : item.color.trim().toUpperCase(), sku: ffSKU?.[0]?.sku, items: data.data && data.data.length ? data.data.filter(items => items.id == itemId) : null
          } : undefined
        }));
      } catch (error) {
        console.log(error)
      }

    } else {
      NotificationManager.error(`Order miss design!`, "Error", 2000);
    }
  };

  const handleOpenDialogFulfil = async (items) => {
    setSelectedItems([])
    setItemEditor(items)
    setOpen5(true)
  };

  const handleCheckBoxFF = async (items) => {
    if (items.fulfil_id) {
      setItemEditor(items)
      setOpen8(true)
    }
  };

  const handleCopyClick = (items) => {
    let data_copy = [items.customer_name, items.address[0], items.address[1], items.address[2], items.address[3], items.address[4], items.address[5], "", items.images]
    NotificationManager.success(`Copied information!`, "Error", 700);
    navigator.clipboard.writeText(data_copy.join("\t"))
      .catch(err => console.error('Failed to copy text: ', err));
  };

  const handleFulFil = async () => {
    let res
    let i = 0
    let newData = []
    Object.keys(selectedItems).forEach(itemId => {
      const item = selectedItems[itemId];
      newData.push({ items: selectedItems[itemId].items, sku: selectedItems[itemId].sku, color: selectedItems[itemId]?.color, size: selectedItems[itemId]?.size, id: selectedItems[itemId]?.id, cate: selectedItems[itemId]?.cate })
      if (ff != "Merchfox" && item != undefined && (!item?.product || !item?.size || !item?.sku)) {
        if (ff == "Mango" && item != undefined && item?.sku) {
        } else if (ff == "Printik" && item != undefined && item?.sku) {
        } else if (ff == "Teecraft" && item != undefined && item?.sku) {
        } else if (ff == "Beeful" && item != undefined && item?.id) { } else if (ff == "PA-Beeful" && item != undefined && item?.id) { }
        else {
          NotificationManager.error(`One item incomplete.`, "Error", 2000);
          newData = []
          i++
          return
        }
      } else if (ff == "Merchfox" && item != undefined) {
        console.log(item)
        if ((!item?.id || !item?.size || !item?.color) && !item.items[0].size.includes("Size: US")) {
          NotificationManager.error(`One item incomplete.`, "Error", 2000);
          newData = []
          i++
          return
        }
      }
    });
    if (ff == "Mango") {
      if (i == 0) {
        res = await dispatch(ffmango({ data: newData }))
      }
    }
    else if (ff == "Printik") {
      if (i == 0) {
        res = await dispatch(ffprintik({ data: newData }))
      }
    }
    else if (ff == "Teecraft") {
      if (i == 0) {
        res = await dispatch(ffteecraft({ data: newData }))
      }
    }
    else if (ff == "Merchfox") {
      if (i == 0) {
        res = await dispatch(ffmerchfox({ data: newData }))
      }
    }
    else if (ff == "Beeful") {
      if (i == 0) {
        res = await dispatch(ffbeeful({ data: newData }))
      }
    }
    else if (ff == "PA-Beeful") {
      if (i == 0) {
        res = await dispatch(ffpabeeful({ data: newData }))
      }
    }
    else if (ff == "Printway") {
      if (i == 0) {
        res = await dispatch(ffprintway({ data: newData }))
      }
    }
    if (res?.payload?.status == 0) {
      setOpen5(false)
      // await dispatch(
      //   getOrders({
      //     store: filterStore, order_status,
      //     startDate: moment(startDate).startOf("day").format("x"),
      //     endDate: moment(endDate).endOf("day").format("x"), currentPage, search, type
      //   })
      // );
      bcrypt.genSalt(10, (err, salt) => {
        bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
          const time = moment().unix()
          const res = await dispatch(getOrders({
            store: filterStore, order_status,
            startDate: moment(startDate).startOf("day").format("x"),
            endDate: moment(endDate).endOf("day").format("x"),
            currentPage,
            search,
            version: hash,
            type
          }))

        });
      })
    } else {

    }
  }

  const handleChangePage = async (newPage) => {
    await dispatch(updateCurrentPage(newPage))
  };

  const handleAddBasecost = async (item) => {
    setItemEditor(item)
    item.basecost != 0 ? setBasecost(item.basecost) : setBasecost("")
    setOpen3(true)
  }
  const handleChangeTracking = async (e) => {
    const res = await dispatch(editOrder({ user, field: "tracking", liststring: [e ? e : tracking, fulfil, lineship], order_id: itemEditor.order_id, store: itemEditor.store_name, id: itemEditor.id, user }))
    if (res.payload.status == 0) {
      // bcrypt.genSalt(10, (err, salt) => {
      //   bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
      //     const time = moment().unix()
      //     const res = await dispatch(getOrders({
      //       store: filterStore, order_status,
      //       startDate: moment(startDate).startOf("day").format("x"),
      //       endDate: moment(endDate).endOf("day").format("x"),
      //       currentPage,
      //       search,
      //       version: hash,
      //       type
      //     }))

      //   });
      // })
    }
    setOpen1(false)
  }

  const handleChangeNote = async (e) => {
    const res = await dispatch(editOrder({ user, field: "note", string: !itemEditor.note ? `${user.replace("@gmail.com", "")}: ${note}` : `${itemEditor.note}\n${user.replace("@gmail.com", "")}:${note}`, id: itemEditor.id }))
    if (res.payload.status == 0) {
      // bcrypt.genSalt(10, (err, salt) => {
      //   bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
      //     const time = moment().unix()
      //     const res = await dispatch(getOrders({
      //       store: filterStore, order_status,
      //       startDate: moment(startDate).startOf("day").format("x"),
      //       endDate: moment(endDate).endOf("day").format("x"),
      //       currentPage,
      //       search,
      //       version: hash,
      //       type
      //     }))

      //   });
      // })
    }
    setOpen2(false)
  }

  const handleChangeColor2 = async (e) => {
    const res = await dispatch(editOrder({ user, field: "color", string: color, id: itemEditor.id }))
    if (res.payload.status == 0) {
      // bcrypt.genSalt(10, (err, salt) => {
      //   bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
      //     const time = moment().unix()
      //     const res = await dispatch(getOrders({
      //       store: filterStore, order_status,
      //       startDate: moment(startDate).startOf("day").format("x"),
      //       endDate: moment(endDate).endOf("day").format("x"),
      //       currentPage,
      //       search,
      //       version: hash,
      //       type
      //     }))

      //   });
      // })
    }
    setOpen6(false)
  }

  const handleChangeSize2 = async (e) => {
    const res = await dispatch(editOrder({ user, field: "size", string: size, id: itemEditor.id }))
    if (res.payload.status == 0) {
      // bcrypt.genSalt(10, (err, salt) => {
      //   bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
      //     const time = moment().unix()
      //     const res = await dispatch(getOrders({
      //       store: filterStore, order_status,
      //       startDate: moment(startDate).startOf("day").format("x"),
      //       endDate: moment(endDate).endOf("day").format("x"),
      //       currentPage,
      //       search,
      //       version: hash,
      //       type
      //     }))

      //   });
      // })
    }
    setOpen7(false)
  }

  const handleClear = async (e) => {
    const res = await dispatch(editOrder({ user, field: "fulfil", id: itemEditor.fulfil_id }))
    if (res.payload.status == 0) {
      // await dispatch(
      //   getOrders({
      //     store: filterStore, order_status,
      //     startDate: moment(startDate).startOf("day").format("x"),
      //     endDate: moment(endDate).endOf("day").format("x"), currentPage, search, type
      //   })
      // );
      bcrypt.genSalt(10, (err, salt) => {
        bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
          const time = moment().unix()
          const res = await dispatch(getOrders({
            store: filterStore, order_status,
            startDate: moment(startDate).startOf("day").format("x"),
            endDate: moment(endDate).endOf("day").format("x"),
            currentPage,
            search,
            version: hash,
            type
          }))

        });
      })
    }
    setOpen8(false)
  }

  const handleChangeBasecost = async (e) => {
    const res = await dispatch(editOrder({ user, field: "basecost", string: basecost, id: itemEditor.id }))
    if (res.payload.status == 0) {
      // bcrypt.genSalt(10, (err, salt) => {
      //   bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
      //     const time = moment().unix()
      //     const res = await dispatch(getOrders({
      //       store: filterStore, order_status,
      //       startDate: moment(startDate).startOf("day").format("x"),
      //       endDate: moment(endDate).endOf("day").format("x"),
      //       currentPage,
      //       search,
      //       version: hash,
      //       type
      //     }))

      //   });
      // })
    }
    setOpen3(false)
  }

  const handleShowInformation = (item) => {
    setItemEditor(item)
    setOpen4(true)
  }

  const handleAddTracking = (item) => {
    setTracking(item.tracking)
    setLineship(item.lineship)
    setFulfil(item.fulfil)
    setItemEditor(item)
    setOpen1(true)
  };

  const handleAddNote = (item) => {
    setNote("")
    setItemEditor(item)
    setOpen2(true)
  };

  const handleClose1 = () => {
    setOpen1(false);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const handleClose3 = () => {
    setOpen3(false);
  };

  const handleClose4 = () => {
    setOpen4(false);
  };

  const handleClose5 = () => {
    setOpen5(false);
  };
  const handleClose6 = () => {
    setOpen6(false);
  };
  const handleClose7 = () => {
    setOpen7(false);
  };
  const handleClose8 = () => {
    setOpen8(false);
  };

  const handleOpenBulkDialog = () => {
    setOpenBulkDialog(true);
    setBulkFF("");
    setBulkStatusFulfil(false);
  };

  const handleCloseBulkDialog = () => {
    setOpenBulkDialog(false);
    setBulkFF("");
    setBulkStatusFulfil(false);
  };

  const handleBulkProcess = async () => {
    const selectedItems = data.data?.filter(item => selectedOrderItems.includes(item.id) && item.price && !item.status_fulfil && !item.fulfil) || [];

    if (selectedItems.length === 0) {
      NotificationManager.error("No items selected for processing!", "Error", 2000);
      return;
    }

    if (!bulkFF.trim()) {
      NotificationManager.error("Please enter FF value!", "Error", 2000);
      return;
    }

    try {
      // Lấy danh sách IDs của các items được chọn
      const selectedIds = selectedItems.map(item => item.id);

      // Gửi bulk request với các thông tin cần thiết
      const bulkData = {
        ids: selectedIds,
        bulkFF: bulkFF.trim(),
        status_fulfil: bulkStatusFulfil,
        user: user
      };

      console.log('Bulk process data:', bulkData);

      // Gọi API bulk update
      const res = await dispatch(bulkUpdateOrders(bulkData));

      if (res.payload?.status === 0) {
        // Refresh data sau khi thành công
        bcrypt.genSalt(10, (err, salt) => {
          bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
            await dispatch(getOrders({
              store: filterStore, order_status,
              startDate: moment(startDate).startOf("day").format("x"),
              endDate: moment(endDate).endOf("day").format("x"),
              currentPage,
              search,
              version: hash,
              type
            }));
          });
        });

        // Clear selection
        setSelectedOrderItems([]);
        setSelectAll(false);
        setOpenBulkDialog(false);
      }

    } catch (error) {
      console.error('Bulk process error:', error);
      NotificationManager.error("Error processing items!", "Error", 2000);
    }
  };



  const changeCheckBox = async (items, checked, field, id) => {
    setItemEditor(items)
    const res = await dispatch(editOrder({ user, field, boolean: checked, id }))
    if (res.payload.status == 0) {
      // bcrypt.genSalt(10, (err, salt) => {
      //   bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
      //     const time = moment().unix()
      //     const res = await dispatch(getOrders({
      //       store: filterStore, order_status,
      //       startDate: moment(startDate).startOf("day").format("x"),
      //       endDate: moment(endDate).endOf("day").format("x"),
      //       currentPage,
      //       search,
      //       version: hash,
      //       type
      //     }))

      //   });
      // })
    }
  }

  const handleChangeColor = async (items) => {
    setItemEditor(items)
    setColor(items.color)
    setOpen6(true)
  }

  const handleChangeSize = async (items) => {
    setItemEditor(items)
    setSize(items.size)
    setOpen7(true)
  }

  const handleChangeShipping = async (items) => {
    setItemEditor(items)
    setShippingMethod(items.shipping_method || "")
    setOpenShippingDialog(true)
  }

  const handleUpdateShipping = async () => {
    const res = await dispatch(editOrder({ user, field: "shipping_method", string: shippingMethod, id: itemEditor.id }))
    setOpenShippingDialog(false)
  }

  const handleCloseShippingDialog = () => {
    setOpenShippingDialog(false)
  }

  const capitalizeAndColorBeforeColon = (note) => {
    const lines = note.split('\n');
    const totalLines = lines.length;
    const linesToShow = 3;

    const displayLines = totalLines > linesToShow
      ? ['...'].concat(lines.slice(totalLines - linesToShow))
      : lines;

    return displayLines.map((line, index) => {
      const [beforeColon, afterColon] = line.split(':', 2);
      const capitalizedBeforeColon = beforeColon.trim().charAt(0).toUpperCase() + beforeColon.trim().slice(1);
      return (
        <div key={index} style={{ marginBottom: index < displayLines.length - 1 ? '4px' : '0' }}>
          <span style={{
            color: '#d32f2f',
            fontWeight: 600,
            fontSize: '11px'
          }}>{capitalizedBeforeColon}</span>
          <span style={{ color: '#666', marginLeft: '3px' }}>: {afterColon ? afterColon.trim() : ""}</span>
        </div>
      );
    });
  };
  function getFirstWords(text) {
    if (text.length > 35) {
      return text.substring(0, 35) + "...";
    } else {
      return text;
    }
  }


  const renderPagination = Array.from({ length: data.totalPage }, (_, index) => index + 1)
    .filter(page =>
      page === 1 || // First page
      page === data.totalPage || // Last page
      Math.abs(page - currentPage) <= 1 // Pages adjacent to the current page
    )
    .map((page, idx, filteredPages) => (
      <>
        {/* Display ellipsis if there's a gap from the previous page */}
        {idx > 0 && page - filteredPages[idx - 1] > 1 && (
          <span key={`ellipsis-${page}`} style={{ padding: "0 5px" }}>...</span>
        )}
        <MDPagination
          item
          key={page}
          onClick={() => handleChangePage(page)}
          active={currentPage === page}
        >
          {page}
        </MDPagination>
      </>
    ));


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ paddingTop: '24px', paddingBottom: '24px' }}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card sx={{
              borderRadius: '16px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
              overflow: 'hidden',
              background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
            }}>
              <div style={{ padding: '24px' }}>
                {selectedOrderItems.length > 0 && (
                  <div style={{
                    marginBottom: '20px',
                    padding: '16px 20px',
                    background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                    borderRadius: '12px',
                    border: '1px solid #90caf9',
                    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.1)'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Icon sx={{ color: '#1976d2', fontSize: '24px' }}>check_circle</Icon>
                        <span style={{ fontWeight: 'bold', color: '#1565c0', fontSize: '15px' }}>
                          {selectedOrderItems.length} item(s) selected
                        </span>
                      </div>
                      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        <button
                          onClick={handleOpenBulkDialog}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '10px 20px',
                            fontSize: '0.875rem',
                            fontWeight: '600',
                            borderRadius: '10px',
                            border: 'none',
                            background: 'linear-gradient(135deg, #00bcd4 0%, #0097a7 100%)',
                            color: '#fff',
                            cursor: 'pointer',
                            textTransform: 'none',
                            boxShadow: '0 2px 8px rgba(0, 188, 212, 0.3)',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 188, 212, 0.4)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 188, 212, 0.3)';
                          }}
                        >
                          <Icon>play_arrow</Icon>
                          Process Selected
                        </button>
                        <button
                          onClick={() => {
                            setSelectedOrderItems([]);
                            setSelectAll(false);
                          }}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '10px 20px',
                            fontSize: '0.875rem',
                            fontWeight: '600',
                            borderRadius: '10px',
                            border: '2px solid #ff9800',
                            background: 'transparent',
                            color: '#ff9800',
                            cursor: 'pointer',
                            textTransform: 'none',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = '#ff9800';
                            e.currentTarget.style.color = '#fff';
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 152, 0, 0.3)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'transparent';
                            e.currentTarget.style.color = '#ff9800';
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = 'none';
                          }}
                        >
                          <Icon>clear</Icon>
                          Clear Selection
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                <HTMLDataTable
                  table={{
                    columns: [
                      {
                        Header: (
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', margin: 0 }}>
                              <input
                                type="checkbox"
                                checked={selectAll}
                                onChange={handleSelectAllChange}
                                ref={(input) => {
                                  if (input) {
                                    input.indeterminate = selectedOrderItems.length > 0 && selectedOrderItems.length < (data.data?.filter(item => item.price && !item.status_fulfil && !item.fulfil).length || 0);
                                  }
                                }}
                                style={{
                                  width: '20px',
                                  height: '20px',
                                  cursor: 'pointer',
                                  accentColor: '#1976d2'
                                }}
                              />
                              <span style={{
                                fontSize: '12px',
                                fontWeight: 'bold',
                                color: '#1976d2',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px'
                              }}>
                                Select All
                              </span>
                            </label>
                          </div>
                        ),
                        accessor: "select",
                        align: "center",
                        width: "100px"
                      },
                      { Header: "Date", accessor: "date", align: "center" },
                      { Header: "Order Id", accessor: "order_id", align: "left" },
                      { Header: "Name", accessor: "items_name", align: "left" },
                      { Header: "Quantity", accessor: "quantity", align: "left" },
                      { Header: "Basecost / Price", accessor: "price", align: "left" },
                      { Header: "Track / Fulfil", accessor: "tracking", align: "left" },
                      { Header: "Note", accessor: "note", align: "left" },
                      { Header: "Design", accessor: "design", align: "left" },
                      { Header: "Status Fulfil", accessor: "status_fulfil", align: "center" },
                      { Header: "Shipping", accessor: "shipping", align: "center" },
                      { Header: "Fulfil", accessor: "fulfil", align: "center" },
                    ],
                    rows: data.data && data.data.length > 0 ? [...data.data.map((items, index) => ({
                      order_status: items.error_order,
                      id: items.order_id,
                      cancel: items.tracking,
                      itemEditor: itemEditor.order_id,
                      select: (items.price && !items.status_fulfil && !items.fulfil) ? (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', margin: 0 }}>
                            <input
                              type="checkbox"
                              checked={selectedOrderItems.includes(items.id)}
                              onChange={handleOrderItemCheckboxChange(items)}
                              style={{
                                width: '20px',
                                height: '20px',
                                cursor: 'pointer',
                                accentColor: '#1976d2'
                              }}
                            />
                          </label>
                        </div>
                      ) : (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '40px' }}>
                          <span style={{
                            fontSize: '10px',
                            color: '#9e9e9e',
                            fontStyle: 'italic'
                          }}>
                            N/A
                          </span>
                        </div>
                      ),
                      date: <>
                        {items.price || search || order_status == "tracking" ? (
                          <span
                            className="caption-text"
                            style={{
                              fontWeight: items?.price > 0 ? "600" : "500",
                              color: items?.price > 0 ? "#212529" : "#6c757d",
                              fontSize: "13px",
                              fontFamily: "monospace"
                            }}
                          >
                            {moment(items.date).format("HH:mm DD/MM")}
                          </span>
                        ) : ""}
                      </>,
                      order_id: <>
                        {
                          items.price || search || order_status == "tracking" ? <>
                            <p className="caption-text" style={{
                              color: items.price ? "#212529" : "#6c757d",
                              fontWeight: items.price ? "600" : "500",
                              fontSize: "13px",
                              marginBottom: "4px"
                            }}> {`${items.order_id}`}</p>
                            <div style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: "4px"
                            }}>
                              {items?.store_name == "Sesverin" || items?.store_name == "Navlak" || items?.store_name == "Ladyjacket" || items?.store_name == "Atorcus" || items?.store_name == "Prashirt" || items?.store_name == "Thalath" ?
                                <img
                                  src="https://egead.nyc3.digitaloceanspaces.com/1728270648803h7puf0.jpg"
                                  style={{
                                    height: "18px",
                                    marginRight: "4px",
                                    borderRadius: "3px"
                                  }}
                                />
                                : null
                              }
                              <p className="caption-text" style={{
                                fontSize: "12px",
                                color: "#6c757d",
                                fontWeight: "500"
                              }}>{`${items.store_name}`}</p>
                            </div>
                          </> : ""}
                      </>,

                      items_name: <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", gap: "12px" }}>
                        {items.images && (
                          <div style={{ flexShrink: 0 }}>
                            <img
                              src={modifyUrlString(items.images)}
                              alt={items.items_name}
                              style={{
                                width: "60px",
                                height: "60px",
                                objectFit: "contain",
                                borderRadius: "8px",
                                border: "1px solid #e9ecef",
                                padding: "4px",
                                background: "#fff",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                                transition: "all 0.2s ease"
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "scale(1.05)";
                                e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "scale(1)";
                                e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                              }}
                            />
                          </div>
                        )}
                        <div style={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }}>
                          <div style={{ marginBottom: "4px" }}>
                            <span
                              className="caption-text"
                              style={{
                                fontWeight: items?.price > 0 ? "500" : "400",
                                fontSize: "13px",
                                color: items?.price > 0 ? "#212529" : "#6c757d"
                              }}
                            >
                              {getFirstWords(items.items_name)}
                            </span>
                            <span className="caption-text" style={{ fontSize: "10px", color: "#6c757d", marginLeft: "6px" }}>{items.sku}</span>
                          </div>
                          <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "4px" }}>
                            <span
                              onClick={!items.status_fulfil ? () => handleChangeSize(items) : null}
                              style={{
                                fontSize: "11px",
                                cursor: items.status_fulfil ? "default" : "pointer",
                                minWidth: "20px",
                                color: "#495057",
                                fontWeight: "500"
                              }}
                            >
                              {items.size.replace("Type: ", "")
                                .replace("Fabric Brand: ", "")
                                .replace("Style: ", "")
                                .replace("Size: ", "")
                                .replace("Product Sides Options: ", "")}
                            </span>
                            <span style={{ color: "#adb5bd" }}>-</span>
                            <span
                              onClick={!items.status_fulfil ? () => handleChangeColor(items) : null}
                              style={{
                                fontSize: "11px",
                                minWidth: "50px",
                                color: "red",
                                fontWeight: "bold",
                                cursor: items.status_fulfil ? "default" : "pointer"
                              }}
                            >
                              {!items.color || items.color == "" ? "None" : items.color}
                            </span>
                            <button
                              style={{
                                width: 22,
                                height: 22,
                                marginLeft: "4px",
                                border: "none",
                                background: "linear-gradient(135deg, #F3C262 0%, #f0b84d 100%)",
                                borderRadius: "50%",
                                fontWeight: "bold",
                                color: "#fff",
                                cursor: "pointer",
                                fontSize: "11px",
                                boxShadow: "0 2px 4px rgba(243, 194, 98, 0.3)",
                                transition: "all 0.2s ease",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }}
                              onClick={() => handleShowInformation(items)}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "scale(1.1)";
                                e.currentTarget.style.boxShadow = "0 3px 6px rgba(243, 194, 98, 0.5)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "scale(1)";
                                e.currentTarget.style.boxShadow = "0 2px 4px rgba(243, 194, 98, 0.3)";
                              }}
                            >!</button>
                            <ContentCopyIcon
                              style={{
                                fontSize: "18px",
                                verticalAlign: "middle",
                                marginLeft: "4px",
                                color: "#1976d2",
                                cursor: "pointer",
                                transition: "all 0.2s ease"
                              }}
                              onClick={() => handleCopyClick(items)}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.color = "#1565c0";
                                e.currentTarget.style.transform = "scale(1.15)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.color = "#1976d2";
                                e.currentTarget.style.transform = "scale(1)";
                              }}
                            />
                          </div>
                        </div>
                      </div>,
                      quantity: (
                        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                          <span className="caption-text" style={{
                            color: "black",
                            fontWeight: "600",
                            fontSize: "14px"
                          }}>{items.quantity}</span>
                          {items.quantity > 1 ? (
                            <ArrowDropUpIcon
                              fontSize="small"
                              style={{
                                color: "#4caf50",
                                fontSize: "18px"
                              }}
                            />
                          ) : null}
                        </div>
                      ),
                      price: items.price || items.basecost || items.status_fulfil ? (
                        <>
                          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                            {(items.price || items.basecost || items.status_fulfil) && (
                              <div
                                onClick={permission.includes("basecost") && (!items.basecost || items.basecost == 0) ? () => handleAddBasecost(items) : null}
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: "6px",
                                  backgroundColor: (!items.basecost || items.basecost == 0) ? '#fff3cd' : 'transparent',
                                  padding: (!items.basecost || items.basecost == 0) ? '4px 8px' : '0',
                                  borderRadius: (!items.basecost || items.basecost == 0) ? '4px' : '0',
                                  cursor: permission.includes("basecost") && (!items.basecost || items.basecost == 0) ? 'pointer' : 'default'
                                }}
                              >
                                <span style={{ fontSize: '0.75rem', color: '#666', fontWeight: 500, minWidth: '70px' }}>Basecost:</span>
                                {items.status_fulfil && items.basecost == 0 ?
                                  <span
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (permission.includes("basecost")) handleAddBasecost(items);
                                    }}
                                    style={{
                                      fontSize: '0.875rem',
                                      fontWeight: 700,
                                      color: '#666',
                                      cursor: 'pointer'
                                    }}
                                  >+</span>
                                  : items?.basecost ? (
                                    <span
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        if (permission.includes("basecost")) handleAddBasecost(items);
                                      }}
                                      style={{
                                        fontSize: '0.875rem',
                                        fontWeight: 700,
                                        color: '#1976d2',
                                        cursor: 'pointer'
                                      }}
                                    >${items.basecost.toFixed(2).toString()}</span>
                                  ) : (
                                    <span
                                      style={{
                                        fontSize: '0.75rem',
                                        fontWeight: 400,
                                        color: '#bbb',
                                        fontStyle: 'italic',
                                        borderBottom: '1px dashed #ddd',
                                        paddingBottom: '1px',
                                        cursor: 'pointer'
                                      }}
                                    >Click to add</span>
                                  )}
                              </div>
                            )}
                            {items.price ? (
                              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "6px" }}>
                                <span style={{ fontSize: '0.75rem', color: '#666', fontWeight: 500, minWidth: '70px' }}>Price:</span>
                                <span style={{
                                  fontSize: '0.875rem',
                                  fontWeight: 700,
                                  color: '#4caf50'
                                }}>${items.price}</span>
                              </div>
                            ) : null}
                          </div>
                        </>
                      ) : null,
                      tracking: (
                        <div style={{ cursor: "pointer", display: "flex", flexDirection: "column", gap: "6px" }}>
                          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "6px" }}>
                            <span style={{ fontSize: '0.7rem', color: '#999', fontWeight: 500, minWidth: '50px' }}>Track:</span>
                            {items?.tracking && !items.tracking.includes("refund") && !items.tracking.includes("cancel") ? (
                              <a
                                href={`https://t.17track.net/en#nums=${items.tracking}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => e.stopPropagation()}
                                style={{
                                  fontSize: '0.8rem',
                                  fontWeight: 600,
                                  color: items.cong ? '#666' : '#00bcd4',
                                  textDecoration: 'none',
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease',
                                  borderBottom: '1px solid transparent'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.color = '#0097a7';
                                  e.currentTarget.style.borderBottomColor = '#0097a7';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.color = items.cong ? '#666' : '#00bcd4';
                                  e.currentTarget.style.borderBottomColor = 'transparent';
                                }}
                              >
                                {items.tracking}
                              </a>
                            ) : items?.tracking ? (
                              <span style={{
                                fontSize: '0.8rem',
                                fontWeight: 600,
                                color: items.tracking.includes("refund")
                                  ? '#ff9800'
                                  : items.tracking.includes("cancel")
                                    ? '#f44336'
                                    : items.cong
                                      ? '#666'
                                      : '#00bcd4'
                              }}>{items.tracking}</span>
                            ) : (
                              <span 
                                style={{
                                  fontSize: '0.75rem',
                                  fontWeight: 400,
                                  color: '#bbb',
                                  fontStyle: 'italic',
                                  borderBottom: '1px dashed #ddd',
                                  paddingBottom: '1px',
                                  cursor: (moment().unix() * 1000 - items.updatedAt > 86400000) || !permission.includes("tracking") ? 'default' : 'pointer'
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (!((moment().unix() * 1000 - items.updatedAt > 86400000) || !permission.includes("tracking"))) {
                                    handleAddTracking(items);
                                  }
                                }}
                              >
                                Click to add
                              </span>
                            )}
                          </div>
                          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "6px" }}>
                            <span style={{ fontSize: '0.7rem', color: '#999', fontWeight: 500, minWidth: '50px' }}>Fulfil:</span>
                            {items.fulfil ? (
                              <span style={{
                                fontSize: '0.8rem',
                                fontWeight: 600,
                                color: items.fulfil.includes("A-")
                                  ? '#1976d2'
                                  : '#ff9800'
                              }}>{items.fulfil}</span>
                            ) : (
                              <span style={{
                                fontSize: '0.75rem',
                                fontWeight: 400,
                                color: '#bbb',
                                fontStyle: 'italic',
                                borderBottom: '1px dashed #ddd',
                                paddingBottom: '1px'
                              }}>Click to add</span>
                            )}
                          </div>
                        </div>
                      ),
                      note: <div style={{ display: "flex", flexDirection: "column", gap: "5px", minWidth: "200px", maxWidth: "250px" }}>
                        {items.price && items.customer_note ? (
                          <div style={{
                            padding: "5px 8px",
                            backgroundColor: "#e3f2fd",
                            borderRadius: "4px",
                            borderLeft: "2px solid #2196f3"
                          }}>
                            <div style={{
                              fontSize: "9px",
                              color: "#1976d2",
                              fontWeight: "bold",
                              marginBottom: "3px",
                              textTransform: "uppercase",
                              letterSpacing: "0.3px"
                            }}>Customer Note</div>
                            <div style={{
                              fontSize: "11px",
                              color: "#333",
                              lineHeight: "1.4",
                              overflowWrap: "break-word",
                              wordWrap: "break-word",
                              whiteSpace: "pre-wrap"
                            }}>{items.customer_note}</div>
                          </div>
                        ) : null}
                        {items.note ? (
                          <div style={{
                            padding: "5px 8px",
                            backgroundColor: "#fff9e6",
                            borderRadius: "4px",
                            borderLeft: "2px solid #ff9800",
                            position: "relative"
                          }}>
                            {permission.includes("note") && (
                              <button
                                onClick={() => handleAddNote(items)}
                                style={{
                                  position: 'absolute',
                                  top: '4px',
                                  right: '4px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: '20px',
                                  height: '20px',
                                  padding: 0,
                                  backgroundColor: 'transparent',
                                  border: 'none',
                                  cursor: 'pointer',
                                  borderRadius: '3px',
                                  transition: 'all 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = 'rgba(255, 152, 0, 0.1)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent';
                                }}
                              >
                                <NoteAddIcon sx={{ fontSize: '14px', color: '#ff9800' }} />
                              </button>
                            )}
                            <div style={{
                              fontSize: "9px",
                              color: "#f57c00",
                              fontWeight: "bold",
                              marginBottom: "4px",
                              textTransform: "uppercase",
                              letterSpacing: "0.3px",
                              paddingRight: permission.includes("note") ? '24px' : '0'
                            }}>Notes</div>
                            <div style={{
                              fontSize: "11px",
                              color: "#333",
                              lineHeight: "1.5",
                              overflowWrap: "break-word",
                              wordWrap: "break-word",
                              whiteSpace: "pre-wrap"
                            }}>{capitalizeAndColorBeforeColon(items.note)}</div>
                          </div>
                        ) : null}
                        {permission.includes("note") && !items.note ? (
                          <button
                            onClick={() => handleAddNote(items)}
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '3px',
                              padding: '3px 8px',
                              fontSize: '0.65rem',
                              fontWeight: 600,
                              color: '#fff',
                              backgroundColor: '#ff9800',
                              border: 'none',
                              borderRadius: '3px',
                              cursor: 'pointer',
                              transition: 'all 0.2s ease',
                              boxShadow: '0 1px 2px rgba(255, 152, 0, 0.2)',
                              alignSelf: 'flex-start'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#f57c00';
                              e.currentTarget.style.boxShadow = '0 2px 4px rgba(255, 152, 0, 0.3)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#ff9800';
                              e.currentTarget.style.boxShadow = '0 1px 2px rgba(255, 152, 0, 0.2)';
                            }}
                          >
                            <NoteAddIcon sx={{ fontSize: '12px' }} />
                            <span>Add Note</span>
                          </button>
                        ) : null}
                      </div>,
                      design: (
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          {items?.design_link ? <div>
                            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                              {items?.design_link?.front ? items?.design_link?.front == "upload" ?
                                <span style={{
                                  fontSize: '0.75rem',
                                  fontWeight: 600,
                                  color: '#ff9800'
                                }}>Uploading</span>
                                : <a
                                  key={0}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href={items?.design_link.front}
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    color: '#1976d2',
                                    textDecoration: 'none',
                                    transition: 'opacity 0.2s ease'
                                  }}
                                  onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                                  onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                                  title="Front Design"
                                >
                                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="3" y="3" width="18" height="18" rx="2" stroke="#1976d2" strokeWidth="2" fill="none" />
                                    <line x1="3" y1="9" x2="21" y2="9" stroke="#1976d2" strokeWidth="2" />
                                    <circle cx="7" cy="6" r="1" fill="#1976d2" />
                                    <circle cx="10" cy="6" r="1" fill="#1976d2" />
                                    <circle cx="13" cy="6" r="1" fill="#1976d2" />
                                  </svg>
                                  <span style={{ fontSize: '0.75rem' }}>Front</span>
                                </a> : null}
                              {items?.design_link?.back ? <a
                                key={1}
                                target="_blank"
                                rel="noopener noreferrer"
                                href={items?.design_link.back}
                                style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  gap: '4px',
                                  color: '#1976d2',
                                  textDecoration: 'none',
                                  transition: 'opacity 0.2s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                                title="Back Design"
                              >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <rect x="3" y="3" width="18" height="18" rx="2" stroke="#1976d2" strokeWidth="2" fill="none" />
                                  <line x1="3" y1="15" x2="21" y2="15" stroke="#1976d2" strokeWidth="2" />
                                  <circle cx="7" cy="18" r="1" fill="#1976d2" />
                                  <circle cx="10" cy="18" r="1" fill="#1976d2" />
                                  <circle cx="13" cy="18" r="1" fill="#1976d2" />
                                </svg>
                                <span style={{ fontSize: '0.75rem' }}>Back</span>
                              </a> : null}
                            </div>
                          </div> : null}

                        </div>
                      ),
                      status_fulfil: (
                        <div>
                          <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', margin: 0 }}>
                            <input
                              type="checkbox"
                              checked={items?.status_fulfil || false}
                              onChange={() => permission.includes("status_fulfil") && !items?.tracking.includes("cancel") && !items?.tracking.includes("refund") && !items.fulfil.includes("A-") ? changeCheckBox(items, items?.status_fulfil, "status_fulfil", items.id) : items.fulfil.includes("A-") && permission.includes("status_fulfil") ? handleCheckBoxFF(items) : null}
                              style={{
                                width: '20px',
                                height: '20px',
                                cursor: (permission.includes("status_fulfil") && !items?.tracking.includes("cancel") && !items?.tracking.includes("refund") && !items.fulfil.includes("A-")) || (items.fulfil.includes("A-") && permission.includes("status_fulfil")) ? 'pointer' : 'not-allowed',
                                accentColor: '#1976d2',
                                opacity: (permission.includes("status_fulfil") && !items?.tracking.includes("cancel") && !items?.tracking.includes("refund") && !items.fulfil.includes("A-")) || (items.fulfil.includes("A-") && permission.includes("status_fulfil")) ? 1 : 0.5,
                                borderRadius: '50%'
                              }}
                            />
                          </label>
                          {items.fulfil.includes("A-") ? <span style={{
                            fontSize: '0.75rem',
                            fontWeight: 600,
                            color: '#666',
                            display: 'block',
                            marginTop: '4px'
                          }}>{items.fulfil_id}</span> : null}
                        </div>
                      ),
                      shipping: (
                        <div style={{ cursor: "pointer" }} onClick={() => handleChangeShipping(items)}>
                          <p>{items.shipping_method}</p>
                        </div>
                      ),
                      fulfil: (
                        <>
                          {items.price && permission.includes("status_fulfil") ? (
                            <button
                              onClick={() => handleOpenDialogFulfil(items)}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '8px',
                                backgroundColor: '#4caf50',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                boxShadow: '0 2px 4px rgba(76, 175, 80, 0.3)',
                                width: '36px',
                                height: '36px'
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#43a047';
                                e.currentTarget.style.boxShadow = '0 4px 8px rgba(76, 175, 80, 0.4)';
                                e.currentTarget.style.transform = 'translateY(-1px)';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#4caf50';
                                e.currentTarget.style.boxShadow = '0 2px 4px rgba(76, 175, 80, 0.3)';
                                e.currentTarget.style.transform = 'translateY(0)';
                              }}
                              title="Fulfil"
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                  fill="#fff"
                                  stroke="#fff"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                          ) : null}
                        </>
                      ), index: true
                    })
                    )] : []
                  }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '20px 0 0 0',
                  marginTop: '20px',
                  borderTop: '1px solid #e9ecef'
                }}>
                  <MDPagination
                    variant="gradient"
                    color="info"
                  >
                    {currentPage > 1 && data.totalPage > 1 && (
                      <MDPagination item onClick={() => handleChangePage(currentPage - 1)}>
                        <Icon sx={{ fontWeight: "bold" }}>chevron_left</Icon>
                      </MDPagination>
                    )}
                    {renderPagination}
                    {currentPage < data.totalPage && (
                      <MDPagination item onClick={() => handleChangePage(currentPage + 1)}>
                        <Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
                      </MDPagination>
                    )}
                  </MDPagination>
                </div>
              </div>
            </Card>
          </Grid>
        </Grid>
      </div>
      <Dialog open={open1} onClose={handleClose1}>
        <DialogTitle>Tracking - Fulfil</DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
            <TextField
              label="Tracking"
              sx={{ margin: "10px" }}
              value={tracking}
              onChange={(e) => setTracking(e.target.value)}
            />
            <TextField
              label="Lineship"
              sx={{ margin: "10px" }}
              value={lineship}
              onChange={(e) => setLineship(e.target.value)}
            />
            <TextField
              label="Fulfil"
              sx={{ margin: "10px" }}
              value={fulfil}
              onChange={(e) => setFulfil(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleChangeTracking("cancel")} variant="outline" style={{ color: "red" }}>
            Cancelled
          </Button>
          <Button onClick={() => handleChangeTracking("refund")} variant="outline" style={{ color: "orange" }}>
            Refunded
          </Button>
          <Button onClick={() => handleChangeTracking()} variant="outline" style={{ color: "green" }}>
            Update
          </Button>
        </DialogActions>
      </Dialog>
      <NoteDialog open2={open2} handleDeleteNote={handleDeleteNote} handleClose2={handleClose2} note2={note} note={itemEditor.note} user={user.replace("@gmail.com", "")} setNote={setNote} handleChangeNote={handleChangeNote} />
      <Dialog open={open3} onClose={handleClose3}>
        <DialogTitle>Basecost</DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
            <TextField
              label="Basecost"
              sx={{ margin: "10px", width: 300 }}
              value={basecost}
              onChange={(e) => setBasecost(e.target.value)}
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleChangeBasecost()} variant="outline" style={{ color: "green" }}>
            Update
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={open4} onClose={handleClose4}>
        <DialogTitle>Information</DialogTitle>
        <DialogContent>
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <GreenSection>
              <CaptionText>Order ID: <InfoText>{itemEditor.order_id}</InfoText></CaptionText>
              <CaptionText>Store: <InfoText>{itemEditor.store_name}</InfoText></CaptionText>
            </GreenSection>
            <hr style={{ marginTop: 10, marginBottom: 10 }} />
            {data.data && data.data.length ? data.data.filter(item => item.order_id === itemEditor.order_id && item.store_name === itemEditor.store_name).map((items, index) => (
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", position: "relative" }} key={index} >
                <BlueSection >
                  <img src={items.images} style={{ width: "60px", objectFit: "contain", marginRight: "10px" }}></img>
                  <div>
                    <CaptionText>
                      <span style={{ marginLeft: 5, marginRight: "5px", fontWeight: '400' }}>{items.items_name}</span>
                    </CaptionText>
                    <CaptionText>
                      <NormalText>{items.size ? items.size.replace("Type: ", "").replace("Fabric Brand: ", "").replace("Style: ", "").replace("Size: ", "").replace("Product Sides Options: ", "") : ""} - <RedText>{items.color}</RedText></NormalText>
                    </CaptionText>
                  </div>
                </BlueSection>
                <span style={{ position: "absolute", top: -7, right: -9, background: "white", borderRadius: "100%", width: "25px", height: "25px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <strong style={{ color: "black" }}>{items.quantity}</strong>
                </span>
              </div>
            )) : null}
            <hr style={{ marginTop: 10, marginBottom: 10 }} />
            <DarkSection>
              <CaptionText2>
                Ship to: <NormalText><HighlightedText>{itemEditor.customer_name}</HighlightedText> - {itemEditor?.address ? `${itemEditor?.address[0]} ${itemEditor?.address[1]}, ${itemEditor?.address[2]}, ${itemEditor?.address[3]} ${itemEditor?.address[4]}, United States` : null}</NormalText>
              </CaptionText2>
              <CaptionText2>
                Email: <NormalText>{itemEditor.email}</NormalText>
              </CaptionText2>
              <CaptionText2>
                Customer Phone: <NormalText>{itemEditor.phone ? itemEditor.phone.includes("+1") ? itemEditor.phone : `+1 ${itemEditor.phone}` : ""}</NormalText>
              </CaptionText2>
            </DarkSection>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog open={open5} onClose={handleClose5} PaperProps={{
        sx: {
          maxWidth: 'md',
          alignItems: "center"
        },
      }}>
        <DialogTitle>Fulfil</DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "80vw" }}>
            <div style={{ display: "flex", flexDirection: "row" }}>
              {ffSite.map(items => (
                <button
                  disabled={items == "Printify" || items == "Burgershop" || items == "Printway"}
                  key={items}
                  onClick={() => {
                    setFf(items)
                    setSelectedItems([])
                  }}
                  style={{
                    margin: '8px',
                    padding: '8px 22px',
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    borderRadius: '4px',
                    border: 'none',
                    cursor: items == "Printify" || items == "Burgershop" || items == "Printway" ? 'not-allowed' : 'pointer',
                    opacity: items == "Printify" || items == "Burgershop" || items == "Printway" ? 0.6 : 1,
                    background: items === ff
                      ? 'linear-gradient(195deg, #4caf50, #43a047)'
                      : 'linear-gradient(195deg, #333, #212121)',
                    color: '#fff'
                  }}
                >
                  {items}
                </button>
              ))}
            </div>
            <div style={{ width: '100%', marginTop: 10 }}>
              {data.data && data.data.length ? (
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd' }}>Select</th>
                      <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd' }}>Item Name</th>
                      <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd' }}>Options</th>
                      <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd' }}>Images</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.data.filter(item => item.order_id === itemEditor.order_id && !item.status_fulfil).map(item => (
                      <tr key={item.id} >
                        <td style={{ padding: '8px', width: "5%" }}>
                          <label style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer', margin: 0 }}>
                            <input
                              type="checkbox"
                              checked={!!selectedItems[item.id]}
                              value={item.id}
                              onChange={handleCheckboxChange(item)}
                              style={{
                                width: '20px',
                                height: '20px',
                                cursor: 'pointer',
                                accentColor: '#1976d2'
                              }}
                            />
                          </label>
                        </td>
                        <td style={{ padding: '8px', width: "30%" }}>
                          <div style={{ fontWeight: item?.price > 0 ? '400' : '' }}>{item.items_name}</div>
                        </td>
                        <td style={{ padding: '8px' }}>
                          {item.size.replace("*", "").replace("Type: ", "")
                            .replace("Fabric Brand: ", "")
                            .replace("Style: ", "")
                            .replace("Size: ", "")
                            .replace("Product Sides Options: ", "").replace("Product Sides: ", "")} -
                          <span style={{ color: 'red', fontWeight: 'bold' }}> {item.color}</span>
                        </td>
                        <td style={{ padding: '8px', display: "flex", flexDirection: "row", alignItems: "center" }}>
                          <span className="caption-text" style={{ fontSize: "10px", margin: 5 }}>Mockup:</span>
                          <a href={modifyUrlString(item?.images)}><img src={modifyUrlString(item?.images)} style={{ height: '70px' }} alt="Mockup" /></a>
                          {item.size.replace("*", "").includes("Both Sides") || item.size.replace("*", "").includes("Front Side Only") || item.size.replace("*", "").includes("Front Side only") || item.size.replace("*", "").includes("Size: US") ?
                            <><span className="caption-text" style={{ fontSize: "10px", margin: 5 }}>Front:</span>
                              <a href={item?.design_link?.front}><img src={item?.design_link?.front} style={{ height: '70px' }} alt="Front" /></a></> : null}
                          {item.size.replace("*", "").includes("Both Sides") || item.size.replace("*", "").includes("Back Side Only") || item.size.replace("*", "").includes("Back Side only") ?
                            <><span className="caption-text" style={{ fontSize: "10px", margin: 5 }}>Back:</span>
                              <a href={item?.design_link?.back}><img src={item?.design_link?.back} style={{ height: '70px' }} alt="Back" /></a></> : null}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : null}
            </div>

            {Object.values(selectedItems).length > 0 && Object.values(selectedItems).filter(items => items != undefined) != 0 ?
              <button
                onClick={handleFulFil}
                style={{
                  margin: '8px',
                  padding: '8px 22px',
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  borderRadius: '4px',
                  border: 'none',
                  cursor: 'pointer',
                  background: 'linear-gradient(195deg, #333, #212121)',
                  color: '#fff'
                }}
              >
                Fulfil
              </button> : null}
          </div>
        </DialogContent>
        <DialogActions>

        </DialogActions>
      </Dialog>
      <Dialog open={open6} onClose={handleClose6}>
        <DialogTitle>Color</DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
            <TextField
              label="Color"
              sx={{ margin: "10px", width: 300 }}
              value={color}
              onChange={(e) => setColor(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleChangeColor2()} variant="outline" style={{ color: "green" }}>
            Update
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={open7} onClose={handleClose7}>
        <DialogTitle>Size</DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
            <TextField
              label="Size"
              sx={{ margin: "10px", width: 800 }}
              value={size}
              onChange={(e) => setSize(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleChangeSize2()} variant="outline" style={{ color: "green" }}>
            Update
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={open8} onClose={handleClose8}>
        <DialogTitle>Delete Fulfil</DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
            <TextField
              label='Enter "ok" to display the delete button'
              sx={{ margin: "10px", width: 300 }}
              value={clear}
              onChange={(e) => setClear(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          {clear == "ok" ? <Button onClick={() => handleClear()} variant="outline" style={{ color: "green" }}>
            Xoá FF
          </Button> : null}
        </DialogActions>
      </Dialog>

      {/* Bulk Process Dialog */}
      <Dialog open={openBulkDialog} onClose={handleCloseBulkDialog} maxWidth="sm" fullWidth>
        <DialogTitle>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Icon sx={{ color: '#1976d2' }}>batch_prediction</Icon>
            <span>Bulk Process Selected Items</span>
          </div>
        </DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px", marginTop: "16px" }}>
            <div>
              <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#666' }}>
                Processing {selectedOrderItems.length} item(s)
              </span>

            </div>

            <TextField
              label="FF (Fulfilment)"
              fullWidth
              value={bulkFF}
              onChange={(e) => setBulkFF(e.target.value)}
              placeholder="Enter FF value (e.g., A-12345)"
              sx={{ marginBottom: 2 }}
              helperText="Enter the fulfilment ID for all selected items"
            />

            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={bulkStatusFulfil}
                onChange={(e) => setBulkStatusFulfil(e.target.checked)}
                style={{
                  width: '20px',
                  height: '20px',
                  cursor: 'pointer',
                  accentColor: '#1976d2'
                }}
              />
              <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                Mark as Status Fulfil
              </span>
            </label>

            <div>
              <span style={{ fontSize: '12px', color: '#666' }}>
                <strong>Note:</strong> This will update all selected items with the same FF value and status fulfil setting.
              </span>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseBulkDialog} variant="outlined" color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleBulkProcess}
            variant="contained"
            color="primary"
            disabled={!bulkFF.trim()}
            startIcon={<Icon>save</Icon>}
          >
            Process Items
          </Button>
        </DialogActions>
      </Dialog>

      {/* Shipping Method Dialog */}
      <Dialog open={openShippingDialog} onClose={handleCloseShippingDialog}>
        <DialogTitle>Edit Shipping Method</DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "16px", marginTop: "16px" }}>
            <TextField
              label="Shipping Method"
              sx={{ margin: "10px", width: 300 }}
              value={shippingMethod}
              onChange={(e) => setShippingMethod(e.target.value)}
              placeholder="Enter shipping method"
            />
            <div style={{ display: "flex", flexDirection: "row", gap: "8px", flexWrap: "wrap" }}>
              <button
                onClick={() => setShippingMethod("Standard Shipping")}
                style={{
                  padding: '6px 16px',
                  fontSize: '0.8125rem',
                  fontWeight: 500,
                  borderRadius: '20px',
                  border: 'none',
                  cursor: 'pointer',
                  textTransform: 'none',
                  background: shippingMethod === "Standard Shipping"
                    ? 'linear-gradient(195deg, #4caf50, #43a047)'
                    : 'linear-gradient(195deg, #333, #212121)',
                  color: '#fff'
                }}
              >
                Standard Shipping
              </button>
              <button
                onClick={() => setShippingMethod("Priority Shipping")}
                style={{
                  padding: '6px 16px',
                  fontSize: '0.8125rem',
                  fontWeight: 500,
                  borderRadius: '20px',
                  border: 'none',
                  cursor: 'pointer',
                  textTransform: 'none',
                  background: shippingMethod === "Priority Shipping"
                    ? 'linear-gradient(195deg, #4caf50, #43a047)'
                    : 'linear-gradient(195deg, #333, #212121)',
                  color: '#fff'
                }}
              >
                Priority Shipping
              </button>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseShippingDialog} >
            Cancel
          </Button>
          <Button onClick={handleUpdateShipping}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>

      <Footer />
    </DashboardLayout >
  );
}

export default Tables;
